import { DestroyRef, Directive, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { BreakpointService } from '@services/breakpoint.service';
import { PositionLoader } from 'cve-ui';

@Directive({})
export class BaseDirective implements OnInit {
    protected breakpoint = '';
    protected positionLoader!: PositionLoader;
    protected _breakpointService = inject(BreakpointService);
    readonly router = inject(Router);
    readonly activatedRoute = inject(ActivatedRoute);

    protected readonly destroyRef = inject(DestroyRef);

    readonly backgroundContent = signal<'white' | 'gray'>('white');

    ngOnInit(): void {
        this._breakpointService.breakpoint$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((breakpoint) => {
            this.breakpoint = breakpoint;
            this.positionLoader =
                (this.router.url.includes('registration') || this.router.url.includes('login')) && !this._breakpointService.minorEqual('tablet')
                    ? PositionLoader.right
                    : PositionLoader.center;
            this.backgroundContent.set(this._breakpointService.minorEqual('phone-landscape') ? 'white' : 'gray');
        });
    }
}
